<template>
  <v-container>
    <v-layout>
      <v-flex xs12 md8>
        <form>
          <v-text-field
            v-model="user.name"
            name="name"
            id="name"
            v-validate="'required|max:150'"
            :error-messages="errors.collect('name')"
            :counter="150"
            type="text"
            label="Имя"
            data-vv-name="name"
            required
          />
          <v-text-field
            v-model="user.username"
            v-validate="'required|max:24|alpha_dash'"
            :error-messages="errors.collect('username')"
            :counter="24"
            @blur="validateField('username')"
            type="text"
            label="Логин"
            data-vv-name="username"
            :loading="checkingFields.includes('username')"
            required
          />
          <v-text-field
            v-model="user.email"
            v-validate="'required|email'"
            @blur="validateField('email')"
            :error-messages="errors.collect('email')"
            label="E-mail"
            name="email"
            id="email"
            type="email"
            data-vv-name="email"
            :loading="isChecking('email')"
            required
          />
          <v-text-field
            v-model="user.phone"
            label="Телефон"
            name="phone"
            id="phone"
            type="text"
            data-vv-name="phone"
            required
          />
          <v-text-field
            v-model="user.skype"
            label="Скайп"
            name="skype"
            id="skype"
            data-vv-name="skype"
            type="text"
            required
          />
          <div class="text-sm-left text-xs-center">
            <v-btn
              depressed
              color="primary"

              @click="save"
              :disabled="isLoading || errors.any() || checkingFields.length > 0"
              :loading="isLoading">
              Сохранить
            </v-btn>
          </div>
        </form>
      </v-flex>
    </v-layout>
    <v-snackbar
      color="success"
      :timeout="5000"
      :bottom="true"
      v-model="success"
    >
      Изменения сохранены.
      <v-btn flat icon @click.native="success = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { clone } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VeeValidateMessagesRU from 'vee-validate/dist/locale/ru'
import UserApi from '../api'

Vue.use(VeeValidate, {
  locale: 'ru',
  dictionary: {
    ru: VeeValidateMessagesRU
  }
})

export default {
  $_veeValidate: {
    validator: 'new'
  },
  name: 'Settings',
  data () {
    return {
      isLoading: false,
      success: false,
      checkingFields: [],
      user: {
        username: '',
        name: '',
        email: '',
        phone: '',
        skype: ''
      },
      dictionary: {
        attributes: {
          name: 'Имя',
          username: 'Логин',
          email: 'E-mail'
          // custom attributes
        },
        custom: {
          name: {
            max: 'The name field may not be greater than 10 characters'
            // custom messages
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters('user', {
      _user: 'user',
      _errors: 'error'
    })
  },
  methods: {
    ...mapActions('user', {
      _getCurrentUser: 'getCurrentUser',
      _saveCurrentUser: 'saveCurrentUser',
      _validateField: 'validateField',
      _setError: 'setError'
    }),
    isChecking (fieldName) {
      // console.log(this.checkingFields.includes(fieldName))
      return this.checkingFields.includes(fieldName)
    },
    async validateField (fieldName) {
      if (this.checkingFields.includes(fieldName)) {
        return false
      }
      this.errors.remove(fieldName)
      // let validateField = true
      await this.$validator.validate(fieldName)
      if (this.errors.has(fieldName)) {
        return false
      }
      this.checkingFields.push(fieldName)
      try {
        let response = await UserApi.validateField({
          fieldName: fieldName,
          fieldValue: this.user[fieldName]
        })
        for (let prop in response.errors) {
          this.errors.add({ field: prop, 'msg': response.errors[prop] })
          this.$validator.fields.find({ name: prop }).setFlags({
            valid: false,
            invalid: true,
            dirty: true
          })
        }
      } catch (error) {
        // console.log(error)
      } finally {
        let index = this.checkingFields.indexOf(fieldName)
        if (index > -1) {
          this.checkingFields.splice(index, 1)
        }
        // pull(this.checkingFields, fieldName)
      }
    },

    async save () {
      this._setError(false)
      this.isLoading = true
      await this.$validator.validateAll()
      if (!this.errors.any()) {
        try {
          await this._saveCurrentUser(this.user)
          this.success = true
          let errors = this._errors
          for (let prop in this._errors) {
            this.errors.add({ field: prop, 'msg': errors[prop] })
            this.$validator.fields.find({ name: prop }).setFlags({
              valid: false,
              invalid: true,
              dirty: true
            })
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.isLoading = false
        }
      }
    }
  },
  async mounted () {
    await this._getCurrentUser()
    this.user = clone(this._user)
    this.$validator.localize('ru', this.dictionary)
  },
  async beforeMount () {
  }
}
</script>

<style scoped>

</style>
